import * as tenantConfigs from '../config/clients';

export const Tenants = {
  HEYDOCTOR: 'heydoctor',
  GOLD: 'gold',
};

interface Tenant {
  Name: string;
  BrochureUrl?: string;
  SquareLogoKey: string;
  LandscapeLogoKey: string;
  Business: {
    OfficePhone: string;
    HelpEmail: string;
  };
  Theme: Record<string, any>;
  Cobranded?: boolean;
  KickoutEnabled?: boolean;
}

interface TenantConstructor {
  config?: Tenant;
}

export class TenantConfig {
  private static instance: TenantConfig;

  private tenant: Tenant;

  constructor(_tenant: TenantConstructor) {
    if (_tenant?.config?.Name) {
      this.tenant = _tenant.config;
    } else {
      this.tenant = tenantConfigs.heydoctor;
    }
  }

  static getInstance(): TenantConfig {
    if (!TenantConfig.instance) {
      TenantConfig.instance = new TenantConfig({});
    }

    return TenantConfig.instance;
  }

  get which() {
    return this.tenant.Name;
  }

  get isHeyDoctor() {
    return this.tenant.Name === 'heydoctor';
  }

  get isGoodRx() {
    return this.tenant.Name === 'goodrx';
  }

  get isGold() {
    return this.tenant.Name === 'gold';
  }

  get name() {
    return this.tenant.Name;
  }

  get config() {
    return this.tenant;
  }

  get squareLogo() {
    const filename = this.tenant.SquareLogoKey ? this.tenant.SquareLogoKey : `${this.tenant}.square.svg`;
    return `https://cdn.heydoctor.com/images/logos/${filename}`;
  }

  get logoSrc() {
    const filename = this.tenant.LandscapeLogoKey ? this.tenant.LandscapeLogoKey : `${this.tenant}.landscape.svg`;
    return `https://cdn.heydoctor.com/images/logos/${filename}`;
  }
}
